import { Layout, Tabs, TabsProps, notification } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import RichTextField from 'src/app/shared/components/common/rich-text-field'
import SentEmailTextsErrorLogs from './sent-email-texts-error-logs'
import SentEmailTextsLogs from './sent-email-texts-logs'

export enum SentEmailTextLogsSetTabs {
  Error = 0,
  NonError = 1,
}

export enum SentEmailTextLogStatus {
  Sent = 'Sent',
  Failed = 'Failed',
}

const SentEmailTextLogsSetup: React.FC = () => {
  const { t } = useTranslation()
  const { state } = useLocation()
  const [api, contextHolder] = notification.useNotification()
  const tabs: TabsProps['items'] = [
    {
      key: SentEmailTextLogsSetTabs.Error.toString(),
      label: t('SentEmailLog:sentEmailLog.tabs.filter_error_logs'),
      children: <SentEmailTextsErrorLogs />,
    },
    {
      key: SentEmailTextLogsSetTabs.NonError.toString(),
      label: t('SentEmailLog:sentEmailLog.tabs.filter_non_error_logs'),
      children: <SentEmailTextsLogs />,
    },
  ]

  useEffect(() => {
    if (state && state?.length > 0) {
      state.forEach((item: any) => {
        item.displayToast &&
          api.success({
            message: <RichTextField richText={item?.message} />,
          })
      })
    }
  }, [state])

  useEffect(() => {
    // clear location state
    window.history.replaceState({}, '')
  }, [])

  return (
    <>
      {contextHolder}
      <Layout.Content
        style={{
          padding: 24,
        }}
      >
        <Tabs defaultActiveKey={SentEmailTextLogsSetTabs.Error.toString()} items={tabs} destroyInactiveTabPane />
      </Layout.Content>
    </>
  )
}

export default SentEmailTextLogsSetup
